import axios from 'axios';
import { constant } from '@app/utils/constant'; 
export const GetIPAddress = async () => {
  try { 
      const response = await axios.get(`${constant.IP_ADDRESS}`, { headers: { "Content-Type": "application/json", "Accept": "application/json" } }); 
      return response.data.IpAddress;
  } catch (err) {
      console.log(err);
  }
}   